import { FC } from "react";
// import { MdKeyboardArrowRight } from "react-icons/md";
import { PropsType } from "./type";

import { SheetClose } from "~/components/ui/sheet";
import useAuthRoute from "~/hook/useAuthRoute";
import { BLUR_HASH, FALLBACK_IMAGE_URL } from "~/utils/constant";
import { wantsMobile } from "~/utils/helper-funcations";
import ImageWithSkeleton from "../ImageWithSkeleton";

const BannerView: FC<PropsType> = ({ data, isImagePreloaded }) => {
  const { handleNavigate } = useAuthRoute();
  return (
    <div>
      {/* <div className="px-5">{category_name && <h2 className="icon_category_type">{category_name}</h2>}</div> */}
      {data.map((item) => {
        const isVisible = wantsMobile(item.show_menu);

        return (
          isVisible && (
            <div
              onClick={() => handleNavigate(item.navigate_to)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleNavigate(item.navigate_to);
                }
              }}
              key={item.id}
              className="xs:pl-5 sml:px-5 py-1 flex flex-col justify-center items-center  "
            >
              <SheetClose className="w-full">
                {/* <motion.img
              variants={touchVariants}
              initial="initial"
              whileTap="tap"
              className="flex w-full  rounded-lg bg-gradient-to-b"
              src={item.icon}
            /> */}

                <ImageWithSkeleton
                  url={{
                    small: typeof item.img === "string" ? item.img : item.img?.s?.url || FALLBACK_IMAGE_URL,
                    medium: typeof item.img === "string" ? item.img : item.img?.m?.url || FALLBACK_IMAGE_URL,
                    large: typeof item.img === "string" ? item.img : item.img?.l?.url || FALLBACK_IMAGE_URL,
                    hd: typeof item.img === "string" ? item.img : item.img?.hd?.url || FALLBACK_IMAGE_URL,
                    original: typeof item.img === "string" ? item.img : item.img?.og?.url || FALLBACK_IMAGE_URL,
                  }}
                  alt={item.name ?? "Icon"}
                  blur_hash={item.img?.bh || BLUR_HASH}
                  className="flex w-full rounded-xl overflow-hidden "
                  // className="flex w-full rounded-lg bg-gradient-to-b"
                  // roundedClass="rounded-lg"
                  isPreloaded={isImagePreloaded?.(typeof item.img === "string" ? item.img : item.img?.s?.url || "") || false}
                  loadImageLazy={false}
                  useSkeletonLoader={true}
                />
                {/* <p className="text-[14px] text-white text-start tracking-wide leading-tight text-wrap font-normal w-full whitespace-pre-line hidden">
                {item.name || "Unnamed Category"}
              </p> */}
                {/* <div className="flex items-center justify-end gap-x-2">
                <div className="h-5 w-5 flex items-center justify-center rounded-full bg-textHeadingColor">
                  <MdKeyboardArrowRight className="text-jetBlack" />
                </div>
              </div> */}
              </SheetClose>
            </div>
          )
        );
      })}
    </div>
  );
};

export default BannerView;
